<template>
  <section class="header">
    <div class="site-topbar">
      <div class="container top-container">
        <div class="region-selection fl">
          <!-- <i class="iconfont icon-menu"></i>
          <span id="place">{{$store.state.user.city}}</span> -->
        </div>
        <div class="topbar-info fr">
          <div class="link fl">
            <a href="https://www.suhuishou.com/company/huishou">企业回收</a>
          </div>
          <div class="link fl">
            <a href="https://www.suhuishou.com/about/5.html">关于我们</a>
          </div>
          <div class="link fl">
            <a href="https://www.suhuishou.com/about/8.html">帮助中心</a>
          </div>
          <div class="link fl">
            <span>服务热线：0755-33528888</span>
          </div>
        </div>
      </div>
    </div>
    <div class="site-header">
      <div class="container">
        <div class="header-logo">
          <h1>
            <a href="https://www.suhuishou.com"
               title="速回收">
              <img src="@/assets/image/logo.png"
                   width="167"
                   alt="速回收">
            </a>
          </h1>
        </div>
        <div class="header-nav">
          <ul>
            <li>
              <a href="https://www.suhuishou.com/shouji">
                手机回收
                <!-- <span>福利</span> -->
                <!-- <div class="tips">
                  <div class="image"></div>
                  <p>扫码关注公众号</p>
                  <p>领现金奖励</p>
                </div> -->
              </a>
            </li>
            <li>
              <a href="https://www.suhuishou.com/laptop">笔记本回收</a>
            </li>
            <li>
              <a href="https://gold.suhuishou.com">黄金回收</a>
            </li>
            <li>
              <a href="https://hx.suhuishou.com">
                以旧换新
                <!-- <span>New</span> -->
              </a>
            </li>
            <li>
              <a href="https://www.suhuishou.com/youpin">二手优品</a>
            </li>
          </ul>
        </div>
        <div class="header-search">
          <input type="text"
                 class="keyword"
                 v-model="keyword"
                 autocomplete="off"
                 placeholder="请输入机型查询">
          <span @click="Search">
            <i class="el-icon-search"></i>
          </span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data () {
    return {
      keyword: ""
    };
  },
  methods: {
    Search () {
      window.location.href =
        "/list?keyword=" + this.keyword;
    }
  }
};
</script>
<style scoped>
.top-container{
  height: 26px;
}
.site-topbar{

}

.topbar-info .link{
  font-size: 12px;
  font-weight: 500;
  color: #666666;
  line-height: 26px;
  margin-left: 32px;
}

.site-header {
  position: relative;
  z-index: 20;
  height: 92px;
  background: #F5F8FA;
  padding: 16px 0;
}
.site-header .header-logo {
  float: left;
  width: 167px;
  margin-right: 66px;
}

.site-header .header-nav {
  position: relative;
  z-index: 10;
  float: left;
  margin: 0;
  padding: 0;
  list-style-type: none;
  font-size: 16px;
  font-weight: 500;
}
.site-header .header-nav ul li {
  display: inline-block;
  position: relative;
}
.site-header .header-nav ul li a {
  display: block;
  padding: 20px 0;
  margin: 0 10px;
  color: #333;
  position: relative;
}
.site-header .header-nav ul li a:hover {
  color: #ef1611;
}
.site-header .header-nav ul li a span {
  display: inline-block;
  content: "";
  position: absolute;
  right: 0px;
  top: 0px;
  width: 36px;
  height: 20px;
  background: #ff4b49;
  font-size: 14px;
  color: #fff;
  line-height: 20px;
  text-align: center;
  border-radius: 2px 0 2px 0;
  font-size: 12px;
}
.site-header .header-nav ul li a span:before {
  display: inline-block;
  content: "";
  border-width: 6px;
  border-color: #ff4b49;
  border-right-width: 0;
  border-style: dashed;
  border-left-style: solid;
  border-top-color: transparent;
  border-bottom-color: transparent;
  position: absolute;
  top: 12px;
  left: 0;
}
.site-header .header-nav ul li:nth-child(1):hover .tips {
  display: block;
}
.site-header .header-nav ul li .tips {
  position: absolute;
  width: 150px;
  height: 200px;
  box-shadow: #ccc 0 0 5px;
  z-index: 99999999;
  top: 60px;
  left: -20px;
  background: #fff;
  display: none;
}
.site-header .header-nav ul li .tips .image {
  width: 140px;
  height: 140px;
  background: url(https://suhuishoutp.oss-cn-shenzhen.aliyuncs.com/assets/image/qrcode.jpg)
    no-repeat;
  background-size: 100%;
  margin: 0px auto 0px;
}
.site-header .header-nav ul li .tips p {
  text-align: center;
}
.site-header .header-nav ul li .tips p:nth-child(2) {
  color: #444;
  margin-bottom: 5px;
}
.container {
  padding: 0;
}
</style>